/**
 * JumpstartBoyToggle — pill toggle for switching between Accelerated Jumpstart,
 * Balance of year, and All views.
 *
 * Default: Accelerated Jumpstart. Persists per user via SprintViewContext.
 * No countdown in the pill label — countdown is per-account, not tenant-wide.
 *
 * No exclamation points. No emojis.
 */
import { useSprintView, type SprintView } from "@/lib/sprint-context";

const labelStyle =
  "px-3 py-1.5 text-xs font-medium rounded-full transition-colors";

export function JumpstartBoyToggle({ compact = false }: { compact?: boolean }) {
  const { view, setView } = useSprintView();

  const opts: { v: SprintView; label: string }[] = [
    { v: "sprint", label: compact ? "Jumpstart" : "Accelerated Jumpstart" },
    { v: "boy", label: "Balance of year" },
    { v: "all", label: "All" },
  ];

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-neutral-200 bg-white p-1 shadow-sm"
      role="tablist"
      aria-label="Goal track view"
    >
      {opts.map((o) => {
        const active = view === o.v;
        return (
          <button
            key={o.v}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => setView(o.v)}
            className={`${labelStyle} ${
              active
                ? "bg-[#0B0B0F] text-white"
                : "text-neutral-600 hover:bg-neutral-50"
            }`}
            data-testid={`jumpstart-toggle-${o.v}`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export default JumpstartBoyToggle;
